import { useIntegrationStore } from '@/modules/Workspaces/KnowledgeHub/useIntegrationStore'
import { computed } from 'vue'

// Not really warranted to have this, probably, but somewhat follows the pattern of other integrations
export const useSharePointConnection = () => {
  const integrationStore = useIntegrationStore()
  return {
    connection: computed(() => integrationStore.findConnection('sharepoint_online')),
  }
}
